import React from "react"
import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material'

const mediaCssNewProjectCard = { height: 196, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }
const ellipsisText = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block'
};

export const NewCard = ({ title, description, type, onClick }) => {
    return (
    <Card sx={{ width: '385px', height: '270px', borderRadius: '10px' }} onClick={()=> onClick(null) }>
      <CardActionArea disableTouchRipple={true} disableRipple={true}>
      <CardMedia
        sx={{ ...mediaCssNewProjectCard }} 
        image='/images/plus.jpg'
        title={title}
      />
        <CardContent>
          <Typography  variant="subtitle2" component="h2" sx={{ ...ellipsisText}}>
            {title}
          </Typography>
          <Typography variant="caption" color="textSecondary" component="p" sx={{ ...ellipsisText}}>
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    );
}